module.exports = __webpack_public_path__ + "static/media/bridge.fde2875b.jpg";